export const navigation = {
  assign(path: string): void {
    window.location.assign(path);
  },
};

/** A full page load to `path`, dropping every in-memory cache and socket. */
export function hardNavigate(path: string): void {
  navigation.assign(path);
}
